// ignore-string-externalization
import { getSilentAuth } from './accessTokenManager/silentAuth';

/**
 *
 * @param continueTo the redirect uri.
 *
 *    **NOTE**: any continueTo URL needs to be specified here: https://webapiadmin.spotify.net/#/app/6cf79a93be894c2086b8cbf737e0796b.
 *    If not specified, the route will give the following error: redirect_uri: Illegal redirect_uri.  For more information, see https://ghe.spotify.net/creator/artists-spotify-com/issues/193
 *
 *    The default route, `/c` is expected to always be used at the time of this writing. For more information see:
 */
export function login(continueTo: string = `${window.location.origin}/c`) {
  const silentAuth = getSilentAuth();
  silentAuth.login({
    redirectUri: continueTo,
  });
}

/**
 *
 * @param continueTo the redirect uri.
 *    The default route, `/home` is expected to always be used at the time of this writing. For more information see:
 */
export function logout(continueTo: string = `${window.location.origin}/home`) {
  const silentAuth = getSilentAuth();
  silentAuth.logout(continueTo);
}
